import { Fork, Invoke } from '@swf/components/StarsWizard/Flow';
import type { FlowConfig } from '@swf/core/types/Wizard';

import useRMFBaseSteps from '.././useRMFBaseSteps';
import RMFAddress from '../../components/RMFAddress/RMFAddress';
import RMFDOB from '../../components/RMFDOB/RMFDOB';
import RMFDepositLimit from '../../components/RMFDepositLimit/RMFDepositLimit';
import RMFLegalName from '../../components/RMFLegalName/RMFLegalName';
import RMFPhone from '../../components/RMFPhone/RMFPhone';
import RMFPlayerFundsProtection from '../../components/RMFPlayerFundsProtection/RMFPlayerFundsProtection';

import { Guard } from './../useRmfGuards';
import { Service } from './../useRmfServices';
import useRmfUKBaseSteps from './useRmfUKBaseSteps';

const useRmfUKPfpFirstFlow = (): FlowConfig => {
  const { jumpToFeatureStep } = useRMFBaseSteps();
  const {
    forkVerification,
    invokeAddressSave,
    invokeMobilePhoneSave,
    invokeRetryEnableRealMoneyFlag,
    invokeEnableRealMoneyFlag,
    invokeUserDataSave,
    forkEKYCFailCheck,
    retryMarker
  } = useRmfUKBaseSteps();

  const invokeRmfDobUpdate = new Invoke(Service.RmfDobUpdate, RMFPlayerFundsProtection, RMFDOB);
  const forkDobCheck = new Fork(
    Guard.RmfDobEnabled,
    [RMFDOB, invokeRmfDobUpdate],
    [RMFPlayerFundsProtection]
  );
  const invokeSignupDob = new Invoke(Service.SignupDobFetch, forkDobCheck);
  const invokeLegalNameSave = new Invoke(Service.RmfLegalNameSave, RMFAddress, RMFLegalName);

  const invokeDepositLimitSave = new Invoke(
    Service.RmfDepositLimitSave,
    invokeUserDataSave,
    RMFDepositLimit
  );

  return [
    invokeSignupDob,
    forkDobCheck,
    RMFPhone,
    invokeMobilePhoneSave,
    RMFLegalName,
    invokeLegalNameSave,
    RMFAddress,
    invokeAddressSave,
    RMFDepositLimit,
    invokeDepositLimitSave,
    invokeUserDataSave,
    invokeEnableRealMoneyFlag,
    retryMarker,
    forkEKYCFailCheck,
    invokeRetryEnableRealMoneyFlag,
    forkVerification,
    jumpToFeatureStep
  ];
};

export default useRmfUKPfpFirstFlow;
